import { Reveal } from "./Reveal";
import { QUALITY_PILLARS } from "../data/content";

export const QualityPillars = ({ dark = false }) => (
  <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
    {QUALITY_PILLARS.map((p, i) => (
      <Reveal key={p.name} delay={i * 0.08} className="h-full">
        <div
          data-testid={`quality-pillar-${p.name.toLowerCase()}`}
          className={`group h-full rounded-2xl border p-6 transition-all duration-500 hover:-translate-y-1 ${
            dark
              ? "border-white/10 bg-white/5 hover:border-gold/60"
              : "border-ink/10 bg-white hover:border-gold hover:shadow-lg"
          }`}
        >
          <div
            className={`grid h-12 w-12 place-items-center rounded-full transition-all duration-500 group-hover:bg-gold group-hover:text-royal ${
              dark ? "bg-white/10 text-gold" : "bg-sand text-wood"
            }`}
          >
            <p.icon className="h-5 w-5" />
          </div>
          <h3
            className={`mt-5 text-xs font-bold uppercase tracking-[0.22em] ${
              dark ? "text-ivory" : "text-ink"
            }`}
          >
            {p.name}
          </h3>
          <p className={`mt-2 text-sm leading-relaxed ${dark ? "text-ivory/60" : "text-ink/60"}`}>
            {p.text}
          </p>
        </div>
      </Reveal>
    ))}
  </div>
);
